/**
* city-select
*/

import Component, { subscribe } from "../../js/lib/component";

const classList = {
  root: ".js-city-select",
  toggle: ".js-city-select-toggle",
  list: ".js-city-select-list",
};

export default class CitySelect extends Component {
  events() {
    this.$.toggle.on("click", e => this.toggle(e));
    this.$.document.on("click", e => this.close(e));
    subscribe("page:esc", () => this.close());
  }
  toggle() {
    this[this.get("opened") ? "close" : "open"].call(this);
  }
  close(e) {
    if (e) {
      const $target = $(e.target);

      const isRoot = $target.is(classList.root);
      const isChilds = $target.closest(classList.root).length > 0;

      if (isRoot || isChilds) return;
    }

    this.$.list.hide();
    this.$.root.removeClass("is-open");
    this.set({ opened: false });
  }
  open() {
    this.$.list.show();
    this.$.root.addClass("is-open");
    this.set({ opened: true });
  }
}

Component.mount(CitySelect, {
  name: "CitySelect",
  classList,
  state: {
    opened: false
  }
});
